function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 9 8",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.314.681a.43.43 0 01.097.32l-.415 4.346a.444.444 0 01-.778.25L3.281.908a.444.444 0 01.382-.723L8.015.53c.116.01.224.062.299.151zM1.345 2.335l3.937 4.692a.444.444 0 01-.382.722L.55 7.403a.432.432 0 01-.3-.15.43.43 0 01-.096-.321l.415-4.346a.444.444 0 01.778-.25z"
}))));